module.exports = __webpack_public_path__ + "img/line-cc.71bac992.svg";